export const environment = {
  staging: true,
  production: false,
  backendUrl: 'https://api.stg.purplme.com/api/',
  GLOBAL_INACTIVITY_TIMER: 180,
  GLOBAL_TIMEOUT_TIMER: 60,
  // allowCashOutSuspension: true,
  firebaseConfig: {
    apiKey: 'AIzaSyDFZZKreLbBmdM0OiN8UEBsX3bfWxW9zO0',
    authDomain: 'purpl-staging.firebaseapp.com',
    projectId: 'purpl-staging',
    storageBucket: 'purpl-staging.firebasestorage.app',
    messagingSenderId: '790142317851',
    appId: '1:790142317851:web:fc6cfbe8601edfaf57cfbe',
    measurementId: 'G-H3KTGY3XVY',
  },
};
